import { lazy } from 'react';

export const MedicalDevicesTypesPage = lazy(
  () => import('./MedicalDevicesTypesPage'),
);
